
import { defineComponent, reactive } from 'vue';

export default defineComponent({
  props: {
    config: Object,
  },
  setup(props) {
    const useConfig = reactive(props.config);
    const imgStore = {
      delete: require('@/assets/img/page/resetDelete.png'),
      add: require('@/assets/img/page/recreate.png'),
      edit: require('@/assets/img/page/reedit.png'),
      look: require('@/assets/img/page/relook.png'),
      // code: require('@/assets/img/page/recode.png'),
      // create: require('@/assets/img/page/recreate.png'),
      // upload: require('@/assets/img/page/reupload.png'),
      // password: require('@/assets/img/page/password.png'),
      // toCharts: require('@/assets/img/page/toCharts.png'),
      // doExport: require('@/assets/img/page/export.png'),
    };
    const useimg = imgStore[useConfig.type];
    return {
      useConfig,
      useimg,
    };
  },
});
